import React, {ComponentProps, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {useHistory} from "react-router-dom";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/presaleOrder";
import * as categoryApi from "../../apis/productCategory";

import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import CategoryCascader from "../../components/CategoryCascader";
import {useRequest} from "ahooks";
import dayjs from "dayjs";
import {Simulate} from "react-dom/test-utils";
import {Button, Space} from "antd";



enum OrderPageType {
    presale='presale', stockout='stockout'
}
enum OrderType{
    presale='preOrder',
    outstock='outStockOrder'
}
const OrderTypeMap={
    preOrder: '预订',
    outStockOrder: '缺货'
}

function PresaleOrderLine(props:ComponentProps<any>){
    const history = useHistory();
    const pageType = history.location.pathname.indexOf('presale')>=0?OrderPageType.presale:OrderPageType.stockout;
    const orderType = pageType ==OrderPageType.presale?OrderType.presale:OrderType.outstock;
    const [categories, setCategories] = useState<Array<any>>([]);
    const {tableProps, download, downloading, form, search} = useAntTable(api.getPresaleOrderLines, {method: 'post', defaultParams: {orderType}, downloadUrl: api.exportLinesUrl});

    const {loading:loadingCategories, run: runCategories} = useRequest(categoryApi.getCategoriesDict, {
        onSuccess(res){
            setCategories(res.data.data);
        }
    });

    const columns: StandardColumnsType=[
        {
            dataIndex: 'orderCode',
            title: `${OrderTypeMap[orderType]}单号`

},
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'hospitalFullName',
            title: '终端医院'
        },
        {
            dataIndex: 'categoryName',
            title: '产品线'
        },
        {
            dataIndex: 'method',
            key: 'method',
            title: '方法',
            width: 100,
        },
        {
            dataIndex: 'useIn',
            key: 'useIn',
            title: '适用机型',
            width: 100,
        },
        {
            dataIndex: 'productCode',
            title: '商品编码'
        },
        {
            dataIndex: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'bookQty',
            title: `${OrderTypeMap[orderType]}数量`
        },
        {
            dataIndex: 'qtyOfOrderNotPlaced',
            title: '未下单数量'
        },
        {
            dataIndex: 'productPrice',
            title: '商品金额'
        },
        {
            dataIndex: 'amount',
            title: '合计金额'
        },
        {
            dataIndex: 'orderDate',
            title: `${OrderTypeMap[orderType]}日期`,
            render(v){
                return v && dayjs(v).format('ll')
            }
        }
    ];
    const searchColumns:StandardColumnsType = [
        {
            dataIndex: 'code',
            title: '单号',
            search: true
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'productCode',
            title: '商品编码',
            search: true
        },
        {
            dataIndex: 'businessMan',
            title: '商务人员',
            search: true
        },
        {
            dataIndex: 'productName',
            title: '商品名称',
            search: true
        },
        {
            dataIndex: 'contractCode',
            title: '合同号',
            search: true
        },
        {
            dataIndex: 'hospitalName',
            title: '终端医院',
            search: true
        },
        {
            dataIndex: 'category',
            title: '产品线',
            search: {
                valueRender(){
                    return <CategoryCascader options={categories} changeOnSelect
                                             fieldNames={{label: "name", children: "children", value: "id"}}/>
                }
            }
        },
        {
            dataIndex: 'orderDateRange',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        },

    ];


    const toolbar = (
        <Space>
            <Button type={"primary"} onClick={download} loading={downloading}>导出Excel</Button>
        </Space>
    )


    return <PageHeaderLayout>
        <StandardTable {...tableProps} form={form} columns={columns} extSearchColumns={searchColumns} search={search} submit={search.submit} toolbar={toolbar}/>
    </PageHeaderLayout>
}

export default PresaleOrderLine;